import { request } from "./api.js";

export function getBillingRecovery(accountId, { signal } = {}) {
  return request(`/api/billing/recovery?accountId=${encodeURIComponent(accountId)}`, { forceFresh: true, signal });
}

export function createCardUpdateLink(accountId) {
  return request("/api/billing/card-update-link", {
    method: "POST", body: JSON.stringify({ accountId }),
  });
}

export function resumeBillingSubscription(accountId, confirmationToken) {
  return request("/api/billing/subscriptions/resume", {
    method: "POST", body: JSON.stringify({ accountId, confirmationToken }),
  });
}
